import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import jwtInterceoptor from "../../../../api/jwtInterceptor";
import { POST_API_URLS, GET_API_URLS } from "../../../../utils/constant";
import AddCarouselForm from "../../../../components/parts/forms/addCarouselForm";
import styles from "./style.module.scss";
import { CardWrapper } from "../../../../components/wrapper";
import { FormErrorPopup } from "../../../../components/parts/popups";
import { Loader } from "../../../../components/ui";

const AddCarousel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [nextIndex, setNextIndex] = useState(1);
  // const [carouselList, setCarouselList] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Get Carousel List to determine next index
    setFormLoading(true);
    jwtInterceoptor
      .get(GET_API_URLS.CAROUSEL)
      .then((response) => {
        setFormLoading(false);
        // setCarouselList(response.data);
        setNextIndex(response.data.length + 1);
      })
      .catch((error) => {
        setFormLoading(false);
        console.log("Error", error);
      });
  }, []);

  const addCarouselHandler = (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let k in data) {
      formData.append(k, data[k]);
    }
    jwtInterceoptor
      .post(POST_API_URLS.ADD_CAROUSEL, formData)
      .then((response) => {
        navigate("/dashboard/carousel");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 400) {
          setError(error.response.data.detail);
        } else {
          setError(error.message);
        }
        console.log("Error", error);
      });
  };

  const updateCarouselHandler = (data) => {
    setLoading(true);
    let formData = new FormData();
    const { id, image, ...restData } = data;

    // Only append image if it exists and has changed
    if (image && image !== "") {
      formData.append("image", image);
    }

    // Append all other data
    for (let k in restData) {
      formData.append(k, restData[k]);
    }

    jwtInterceoptor
      .patch(`${POST_API_URLS.ADD_CAROUSEL}${id}/`, formData)
      .then((response) => {
        navigate("/dashboard/carousel");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 403) {
          setError("You don't have permission to edit carousel.");
        } else {
          setError(error.message);
        }
        console.log("Error", error);
      });
  };

  return (
    <>
      <div className={styles.addPromotionContainer}>
        <CardWrapper>
          {formLoading ? (
            <Loader />
          ) : (
            <AddCarouselForm
              updateData={updateCarouselHandler}
              data={addCarouselHandler}
              loading={loading}
              formInitialValues={location.state || null}
              nextIndex={nextIndex}
            />
          )}
        </CardWrapper>
      </div>
      {error && <FormErrorPopup error={error} close={() => setError(false)} />}
    </>
  );
};

export default AddCarousel;
